const REGISTRATION_FULL_PATTERN = /registration (is )?full/i

const matchesRegistrationFull = message =>
  typeof message === 'string' && REGISTRATION_FULL_PATTERN.test(message)

export const isRegistrationFullError = errorOrMessage => {
  if (!errorOrMessage) return false
  if (typeof errorOrMessage === 'string') {
    return matchesRegistrationFull(errorOrMessage)
  }

  return [
    errorOrMessage.message,
    ...(errorOrMessage.graphQLErrors || []).map(({ message }) => message),
  ].some(matchesRegistrationFull)
}
